// extracted by mini-css-extract-plugin
module.exports = {"formSection":"styles_formSection__IV6GW","adminFeatures":"styles_adminFeatures__2ylOD"};